import { useState, useEffect } from "react";
import "./QuestionSettingsEnd.css";
import { QuestionSelector } from "../question-selector/QuestionSelector";
import { Question, QuestionType, UpdateQuestionPayload } from "effno-core";
import { apiUpdateQuestion } from "../../services/QuestionService";
import toast from "react-hot-toast";
import { toastFail } from "../../config";
import { MySwitch } from "../form-widgets/MySwitch";

type QuestionSettingsEndProps = {
    question: Question;
    onChange: (question: Question) => void;
}

export const QuestionSettingsEnd = ({question, onChange} : QuestionSettingsEndProps) => {

    const [settings, setSettings] = useState<any | null>(JSON.parse(question.settings));
    const [type, setType] = useState<QuestionType>(question.type);
    const [required, setRequired] = useState<boolean>(question.required);

    useEffect(() => {
        setSettings(JSON.parse(question.settings));
        setRequired(question.required);
        setType(question.type);
    }, [question]);

    const handleTypeChange = async (value: string) => {
        console.log("[QuestionSettingsShort/handleTypeChange] value: ", value);
    }

    // const handleRequiredChange = async (checked: boolean) => {
    //     setRequired(checked);

    //     const payload: UpdateQuestionPayload = {
    //         questionId: question.id,
    //         type,
    //         title: question.title,
    //         description: question.description,
    //         required: checked,
    //         settings: JSON.stringify(settings),
    //         conditions: question.conditions
    //     }

    //     updateSettings(payload);
    // }

    const handleSettingChange = async (e: any) => {
        console.log("[QuestionSettingsEnd/handleSettingChange] e: ", e);

        let newSettings = {...settings};

        switch (e.target.name) {
            default:
                newSettings = {...settings, [e.target.name]: e.target.value};
        }

        setSettings(newSettings);

        const payload: UpdateQuestionPayload = {
            questionId: question.id,
            type,
            title: question.title,
            description: question.description,
            required,
            settings: JSON.stringify(newSettings),
            conditions: question.conditions
        }

        updateSettings(payload)
    }

    const handleSwitchSettings = async (name: string, checked: boolean) => {
        console.log("[QuestionSettingsContact/handleSwitchSettings] name: ", checked);

        let newSettings = {...settings};

        switch (name) {
            case "socialShareOn":
            case "brandingOn":
                newSettings = {...settings, [name]: checked};
                break;
            default:
                // nadad
        }

        setSettings(newSettings);

        const payload: UpdateQuestionPayload = {
            questionId: question.id,
            type,
            title: question.title,
            description: question.description,
            required,
            settings: JSON.stringify(newSettings),
            conditions: question.conditions
        }

        updateSettings(payload)
    }

    // have to send in the payload here due to react setting asyncs
    const updateSettings = async(payload: UpdateQuestionPayload) => {

        const newQuestion = await apiUpdateQuestion(payload);

        if (!newQuestion) {
            toast("Error updating question", toastFail);
            return;
        }

        // update UI
        onChange(newQuestion);
    }

    // console.log("[QuestionSettingsEnd] settings: ", settings);

    return (        
        <>
            <div className="question-settings-end">
                <QuestionSelector defaultValue={type} onChange={handleTypeChange}/>

                <div className="question-setting-divider">{}</div>

                <div className="question-setting">
                    <div className="question-setting-label">
                        Social Buttons
                    </div>
                    <div className="question-setting-checkbox">
                        <MySwitch 
                            id="socialShareOn"
                            checked={settings?.socialShareOn}
                            onChange={(checked: boolean) => 
                                handleSwitchSettings("socialShareOn", checked)
                            }
                        />
                    </div>
                </div>

                <div className="question-setting">
                    <div className="question-setting-label">
                        Branding
                    </div>
                    <div className="question-setting-checkbox">
                        <MySwitch 
                            id="brandingOn"
                            checked={settings?.brandingOn}
                            onChange={(checked: boolean) => 
                                handleSwitchSettings("brandingOn", checked)
                            }
                        />
                    </div>
                </div>

            </div>
            
        </>
    )
}